import {useCallback, useState} from 'react';
import {Alert, ScrollView, View} from 'react-native';
import {useFocusEffect} from '@react-navigation/native';
import {Button, TextInput} from 'react-native-paper';
import {Text} from '../../Components';
import {PageContainer} from '../../Containers';
import {useTheme} from '../../Hooks';
import {RootProviderLoginScreenProps} from '../../Typings/NavigationTypes';
import {
  DEMO_PROVIDER_PIN,
  loadProviderSession,
  saveProviderSession,
} from '../../Utils/ProviderSession';
import getStyles from './ADAPT-MH.styles';

type Props = RootProviderLoginScreenProps;

const ProviderLogin: React.FC<Props> = ({navigation}) => {
  const theme = useTheme();
  const styles = getStyles(theme);
  const [pin, setPin] = useState('');

  useFocusEffect(
    useCallback(() => {
      const checkSession = async () => {
        const session = await loadProviderSession();
        if (session) {
          navigation.replace('ProviderDashboard');
        }
      };

      checkSession();
    }, [navigation]),
  );

  const onLoginPress = async () => {
    if (pin !== DEMO_PROVIDER_PIN) {
      Alert.alert('Demo PIN required', 'Use PIN 2468 for the local provider demo.');
      return;
    }

    await saveProviderSession();
    navigation.replace('ProviderDashboard');
  };

  return (
    <PageContainer withSafeArea withPadding>
      <ScrollView contentContainerStyle={styles.scrollContent}>
        <View style={styles.hero}>
          <Text
            fontSize={30}
            lineHeight={37}
            weight="black"
            accessibilityRole="header"
            style={styles.title}
          >
            Provider login
          </Text>
          <Text fontSize={16} lineHeight={24} style={styles.subtitle}>
            This PIN is only a local prototype guard. It is not production authentication.
          </Text>
        </View>

        <View style={styles.card}>
          <Text weight="bold" fontSize={17} style={styles.strongBody}>
            Provider demo login
          </Text>
          <Text style={styles.listItem}>
            Use this local demo view to review shared assessment summaries.
          </Text>

          <TextInput
            mode="outlined"
            label="Demo PIN"
            value={pin}
            onChangeText={setPin}
            secureTextEntry
            keyboardType="number-pad"
            style={styles.input}
          />

          <Button
            mode="contained"
            onPress={onLoginPress}
            style={styles.button}
            buttonColor={theme.colors.primary}
            textColor={theme.colors.textContrast}
          >
            Enter provider view
          </Button>
        </View>
      </ScrollView>
    </PageContainer>
  );
};

export default ProviderLogin;
